function getGraphType(type) {
    switch (type) {
        case "leaf-wetness":
            return "bar";
        default:
            return "area";
    }
}

export default getGraphType;